// extracted by css-extract-rspack-plugin
export default {"wrapper":"_1e7e6a9","iconicDesignsTable":"_8c656124","designLink":"_57e4ff28","designThumbnail":"_e0ade2c4","designName":"_7d77540f"};